(function () {
  'use strict';

  var TRACKING_ID_PATTERN = /^[A-Za-z0-9-]{6,30}$/;
  var LOADING_DURATION = 900;

  /*
    Each courier's URL was verified by hand: submit their own tracking form
    and inspect where it actually navigates to.

    - PostEx: submitting their form navigates to /tracking?cn=<id>, which
      loads with the result already shown. Confirmed by loading that URL
      cold (no prior form visit) and seeing the result render immediately.
    - Leopards: submitting their form on pk.leopardscourier.com navigates to
      /shipment_tracking_view?cn_number=<id>, a plain GET with no session
      token required — confirmed by loading it cold in a fresh tab and
      seeing the result render immediately.
    - TRAX (sonic.pk): their tracking form submits via client-side JS to a
      POST endpoint (/tracking/track) — confirmed via network inspection.
      The URL never changes and no query parameter is read on load, so
      there's no GET/URL-parameter mechanism to link to directly. A hidden
      auto-submit form isn't used either: their POST is same-origin AJAX,
      not a plain form action, so it's not something a third-party page can
      reliably trigger. The button below opens their tracking page as
      instructed; the tracking number can't be passed automatically
      because Sonic doesn't expose a supported mechanism for it.
  */
  var COURIERS = {
    leopards: {
      label: 'Leopards',
      buildUrl: function (id) {
        return 'https://pk.leopardscourier.com/shipment_tracking_view?cn_number=' + encodeURIComponent(id);
      }
    },
    postex: {
      label: 'PostEx',
      buildUrl: function (id) {
        return 'https://postex.pk/tracking?cn=' + encodeURIComponent(id);
      }
    },
    trax: {
      label: 'TRAX',
      buildUrl: function () {
        return 'https://sonic.pk/tracking';
      }
    }
  };

  var root = document.getElementById('track-order');
  if (!root) return;

  var input = document.getElementById('track-order-input');
  var errorEl = document.getElementById('track-order-error');
  var buttons = root.querySelectorAll('[data-courier]');
  var loadingTimer = null;

  function showError(message) {
    errorEl.textContent = message;
    errorEl.hidden = false;
    input.setAttribute('aria-invalid', 'true');
    input.classList.remove('is-shake');
    void input.offsetWidth;
    input.classList.add('is-shake');
  }

  function clearError() {
    errorEl.hidden = true;
    errorEl.textContent = '';
    input.removeAttribute('aria-invalid');
  }

  function setButtonLoading(button, isLoading) {
    button.disabled = isLoading;
    button.classList.toggle('is-loading', isLoading);
  }

  function handleCourierClick(event) {
    var button = event.currentTarget;
    var courier = COURIERS[button.getAttribute('data-courier')];
    if (!courier) return;

    clearError();
    var trackingId = input.value.trim();

    if (!trackingId) {
      showError('Please enter your tracking number.');
      input.focus();
      return;
    }

    if (!TRACKING_ID_PATTERN.test(trackingId)) {
      showError('That tracking number format looks invalid. Please double-check and try again.');
      input.focus();
      return;
    }

    window.open(courier.buildUrl(trackingId), '_blank', 'noopener,noreferrer');

    setButtonLoading(button, true);
    window.clearTimeout(loadingTimer);
    loadingTimer = window.setTimeout(function () {
      setButtonLoading(button, false);
    }, LOADING_DURATION);
  }

  buttons.forEach(function (button) {
    button.addEventListener('click', handleCourierClick);
  });

  input.addEventListener('input', function () {
    if (!errorEl.hidden) clearError();
  });
})();
